import { render, staticRenderFns } from "./DocsHistory.vue?vue&type=template&id=69d483b7"
import script from "./DocsHistory.vue?vue&type=script&lang=js"
export * from "./DocsHistory.vue?vue&type=script&lang=js"
import style0 from "./DocsHistory.vue?vue&type=style&index=0&id=69d483b7&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports